var _path, _circle, _circle2, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.798H19.7222C20.704 21.798 21.5 21.0021 21.5 20.0202V15.6378C21.5 14.3856 20.9209 13.1803 19.7933 12.6356C18.8998 12.2039 17.7554 11.798 16.6111 11.798C15.0131 11.798 13.4151 12.5894 12.5 13.1375C11.5849 12.5894 9.98691 11.798 8.38891 11.798C7.24457 11.798 6.10023 12.2039 5.20667 12.6356C4.07913 13.1803 3.5 14.3856 3.5 15.6378V20.0202C3.5 21.0021 4.29596 21.798 5.27782 21.798H6.5",
    stroke: "#6E6E6E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.3727,
    cy: 6.07076,
    r: 2.27273,
    stroke: "#6E6E6E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7727,
    cy: 6.07076,
    r: 2.27273,
    stroke: "#6E6E6E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.663L13.562 17.298L14 16.9331V17.663Z",
    fill: "#14AA3C",
    stroke: "#14AA3C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.9331L11.438 20.298L11 20.663V19.9331Z",
    fill: "#14AA3C",
    stroke: "#14AA3C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.298H8.5",
    stroke: "#14AA3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.298H15",
    stroke: "#14AA3C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario15);
export default __webpack_public_path__ + "static/media/Scenario15.66ecae1ae4dbcace173e45f98ca74f7f.svg";
export { ForwardRef as ReactComponent };